module.exports = "../../app/cells/components/course_suggestions_filter_cell.rb";